module.exports = __webpack_public_path__ + "img/lafia-magic-caution.dd7e99e9.png";